import useStore from '@/store/useStore'

export const usePageOptionsUpdate = (isPopup?: boolean) => {
  const setPageTabIndex = useStore((state) => state.page.setTabIndex)
  const setPagePopupTabIndex = useStore((state) => state.popup.setTabIndex)
  const setTabIndex = isPopup ? setPagePopupTabIndex : setPageTabIndex

  const setPageSlideIndex = useStore((state) => state.page.setSlideIndex)
  const setPagePopupSlideIndex = useStore((state) => state.popup.setSlideIndex)
  const setSlideIndex = isPopup ? setPagePopupSlideIndex : setPageSlideIndex

  const setPageAnchorId = useStore((state) => state.page.setPageAnchorId)
  const setPagePopupAnchorId = useStore(
    (state) => state.popup.setPagePopupAnchorId,
  )
  const setAnchorId = isPopup ? setPagePopupAnchorId : setPageAnchorId

  const setPageFocusId = useStore((state) => state.page.setPageFocusId)
  const setPagePopupFocusId = useStore(
    (state) => state.popup.setPagePopupFocusId,
  )
  const setFocusId = isPopup ? setPagePopupFocusId : setPageFocusId

  const resetPageOptions = () => {
    setFocusId('')
    setAnchorId('')
  }
  return {
    setTabIndex,
    setSlideIndex,
    setAnchorId,
    setFocusId,
    resetPageOptions,
  }
}
